var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#key_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.817 9.494V8.407h1.092V7.32H15V2.97H13.91V1.884h-1.092V.797H8.451v1.087H7.36v1.087H6.268v3.261H7.36V7.32H6.268v1.087H5.177v1.087H4.085v1.087H2.994v1.087H1.902v1.087H.811v2.174h2.183v-1.087h1.091v2.174h1.092V14.93h1.091v-1.087H7.36v-1.087H5.177v-1.087h1.091v-1.087H7.36V9.494H8.45V8.407h1.092v1.087h3.274ZM8.451 6.232V4.058h1.092V2.971h2.183v1.087h1.091v2.174h-1.091V7.32H9.543V6.232H8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.725 4.1h-1.15v1.062H9.513v1.062H11.725V4.102Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "key_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgKey;